import { inject, Service } from '@angular/core';
import { ErrorHandlingService } from '@errors/error-handling.service';
import { MbmModalMessageService } from './mbm-modal-message.service';

@Service({ autoProvided: false })
export class MbmModalService {
  private readonly errorHandlingService = inject(ErrorHandlingService);
  private readonly messageService = inject(MbmModalMessageService);

  readonly errorMessages = this.messageService.errorMessages;
  readonly successMessages = this.messageService.successMessages;

  async handleErrorAsync(error: unknown, messageKey?: string): Promise<never> {
    return this.errorHandlingService.handleErrorAsync(error, messageKey);
  }

  showSuccessMessage(messageKey: string): void {
    this.messageService.showSuccessMessage(messageKey);
  }

  showErrorMessage(messageKey: string): void {
    this.messageService.showErrorMessage(messageKey);
  }
}
